"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MatchingStep = void 0;
const BaseUserOnboardingStep_1 = require("../../../common/domain/BaseUserOnboardingStep");
const HodOnboardingStepId_1 = require("../HodOnboardingStepId");
const MatchingData_1 = require("./MatchingData");
const validator_1 = require("@leavy/validator");
class MatchingStep extends BaseUserOnboardingStep_1.BaseUserOnboardingStep {
    constructor() {
        super(...arguments);
        this.stepId = HodOnboardingStepId_1.HodOnboardingStepId.HOD_MATCHING;
    }
    getDataConstructor() {
        return MatchingData_1.MatchingData;
    }
    getDefaultData() {
        return new MatchingData_1.MatchingData();
    }
}
__decorate([
    (0, validator_1.Type)(() => MatchingData_1.MatchingData),
    __metadata("design:type", MatchingData_1.MatchingData)
], MatchingStep.prototype, "data", void 0);
exports.MatchingStep = MatchingStep;
//# sourceMappingURL=MatchingStep.js.map